export default __webpack_public_path__ + "assets/logoDropbox.7295e68d.png";